import request from "@/utils/request";
import tools from "@/utils/Tool";

/**
 * 获取题目
 * @param data
 * @returns {*}
 */
export function huoqutimu(data) {
  return request({
    url: "pcapi/subject/huoqutimu",
    method: "post",
    data: data,
  });
}

/**
 * 取消收藏
 * @param data
 * @returns {*}
 */
export function shoucangdel(data) {
  return request({
    url: "pcapi/subject/shoucangdel",
    method: "post",
    data: data,
  });
}

/**
 * 收藏题目
 * @param data
 * @returns {*}
 */
export function shoucangtimu(data) {
  return request({
    url: "pcapi/subject/shoucangtimu",
    method: "post",
    data: data,
  });
}

/**
 * 单个题目收藏
 */
export function questioncollect(data) {
  return request({
    url: "/api/collect/question-single",
    method: "post",
    data: data,
  });
}

export function submitSkillSuggestion(data) {
  return request({
    url: "/pc/subject/skill-feedback",
    method: "post",
    data,
  });
}

/**
 * 答题交卷
 * @param data
 * @param is_submit
 * @returns {*}
 */
export function dati_jiaojuan(data, is_submit) {
  const data_transform = {
    exam_paper_id: data.sj_id || "",
    use_time: data.long_time || [],
    subject_base_ids: data.timu_id || [],
    is_submit: is_submit === true ? 1 : 0,
    answer_options: data.huida_AnswerTrue,
    ...(data.is_anew ? { is_anew: data.is_anew } : {}), // 是否重新开始答题 1是 0否
  };
  return request({
    url: "/api/subject/exam/exam-paper-submit",
    method: "post",
    data: data_transform,
  });
}

/**
 * 交卷
 * @param data
 * @returns {*}
 */
export function jiaojuan(data) {
  return request({
    url: "pcapi/subject/jiaojuan",
    method: "post",
    data: data,
  });
}

/**
 * 新题试卷
 * @param data
 * @returns {*}
 */
export function xintisj(data) {
  return request({
    url: "pcapi/subject/xintisj",
    method: "post",
    data: data,
  });
}
/**
 * 新规
 * @param data
 * @returns {*}
 */
export function xinguiisj(data) {
  return request({
    url: "/api/subject/exam/drive-specific-course",
    method: "post",
    data: data,
  });
}

export function difanglianxi(data) {
  return request({
    url: "/api/subject/exam/driver-place",
    method: "post",
    data: data,
  });
}

export function freeTrial(data = {}) {
  return request({
    url: "/api/subject/exam/drive-vip-free-trial",
    method: "post",
    data,
  });
}

/**
 * 对比题试卷
 * @param data
 * @returns {*}
 */
export function duibitisj(data) {
  return request({
    url: "/api/subject/exam/exam-paper-chapter-question-review",
    method: "post",
    data: data,
  });
}

/**
 * 考试规则
 * @param data
 * @returns {*}
 */
export function huoquksgz(data) {
  return request({
    url: "/api/subject/exam/exam-rule-detail",
    method: "get",
    params: data,
  });
}

/**
 * 三力考试规则
 */

export function sanli_ksgz(data) {
  return request({
    url: "/api/subject/exam/three-force-exam-rule-detail",
    method: "get",
    params: data,
  });
}

/**
 * 三力读秒题
 * @param data
 * @returns {*}
 */
export function sanli_dumiao(data) {
  return request({
    url: "/api/subject/exam/three-force-specific",
    method: "get",
    params: data,
  });
}

/**
 * 进度
 * @param data
 * @returns {*}
 */
export function jindu(data) {
  return request({
    url: "pcapi/subject/jindu",
    method: "post",
    data: data,
  });
}

/**
 * V3进度
 * @param data
 * @returns {*}
 */
export function subjectprogress(data) {
  return request({
    url: "/api/user/process",
    method: "get",
    params: data,
  });
}

/**
 * 获取试卷
 * @param data
 * @param menuType
 * @param useLabel
 * @param categoryid
 * @returns {*}
 */
export function getpagers(
  data,
  menuType = "",
  useLabel = "",
  categoryid = "",
  baseid = "",
  real = false
) {
  const bool_result = tools.is_qualification();
  if (useLabel == "sanli") {
    return request({
      url: real
        ? "/api/subject/exam/three-force-mock"
        : "/api/subject/exam/three-force-practice",
      method: "post",
    });
  }
  console.log("我的职业资格判断", bool_result, menuType);

  if (!bool_result) {
    // 驾驶证
    if (menuType == "vip") {
      data.subject_category_id = Number(categoryid);
      return request({
        url: "/api/subject/exam/drive-vip-course",
        method: "post",
        data: data,
      });
    } else if (menuType == "add") {
      return request({
        url: "/api/subject/exam/drive-new-add",
        method: "post",
        data: data,
      });
    } else if (menuType == "500") {
      data.subject_category_id = Number(categoryid);
      return request({
        url: "/api/subject/exam/drive-vip-course",
        method: "post",
        data: data,
      });
    } else if (menuType == "kaoqianmijuan") {
      data.subject_category_id = Number(categoryid);
      return request({
        url: "/api/subject/exam/drive-secret",
        method: "post",
        data: data,
      });
    } else if (menuType == "zhuanxianglianxi") {
      data.subject_category_id = Number(categoryid);
      return request({
        url: "/api/subject/exam/drive-specific-practice",
        method: "post",
        data: data,
      });
    } else if (menuType == "cuoti") {
      // 错题
      if (categoryid) {
        data.subject_category_id = Number(categoryid);
      } else {
        data.subject_base_id = Number(baseid);
      }
      return request({
        url: "/api/collect/exam-paper-wrong-memory",
        method: "get",
        params: data,
      });
    } else if (menuType == "shijuancuoti") {
      return request({
        url: `/api/subject/exam/exam-paper-wrong-question-review/${baseid}`,
        method: "get",
      });
    } else if (menuType == "shoucang") {
      // 题目收藏
      if (categoryid) {
        data.subject_category_id = Number(categoryid);
      } else {
        data.subject_base_id = Number(baseid);
      }
      return request({
        url: "/api/collect/exam-paper-question-memory",
        method: "get",
        params: data,
      });
    } else {
      return request({
        url: "/pc/subject/exam/drive-practice",
        method: "post",
        data: data,
      });
    }
  } else if (menuType == "500") {
    data.subject_category_id = Number(categoryid);
    return request({
      url: "/api/subject/exam/qualification-specific-practice",
      method: "post",
      data: data,
    });
  } else {
    if (menuType == "shijuancuoti") {
      return request({
        url: `/api/subject/exam/exam-paper-wrong-question-review/${baseid}`,
        method: "get",
      });
    }
    if (menuType == "shoucang") {
      // 题目收藏
      if (categoryid) {
        data.subject_category_id = Number(categoryid);
      } else {
        data.subject_base_id = Number(baseid);
      }
      return request({
        url: "/api/collect/exam-paper-question-memory",
        method: "get",
        params: data,
      });
    }
    if (menuType == "cuoti") {
      // 错题
      if (categoryid) {
        data.subject_category_id = Number(categoryid);
      } else {
        data.subject_base_id = Number(baseid);
      }
      return request({
        url: "/api/collect/exam-paper-wrong-memory",
        method: "get",
        params: data,
      });
    }
    // 资格证
    return request({
      url: "/api/subject/exam/qualification-practice",
      method: "post",
      data: data,
    });
  }
}

/**
 * 交卷
 */
export function jiaojuanv3(data) {
  return request({
    url: "/api/subject/exam/exam-paper-submit",
    method: "post",
    data: data,
  });
}

/**
 * 试卷历史列表
 */
export function paperhistory(data) {
  return request({
    url: "/pc/subject/exam/exam-paper-list",
    method: "get",
    params: data,
  });
}

/**
 * 删除试卷
 */
export function paperdelete(id) {
  return request({
    url: "/api/subject/exam/exam-paper-delete",
    method: "post",
    data: { ids: [id] },
  });
}
/**
 * 清空所有试卷
 */
export function paperAlldelete(data) {
  return request({
    url: "/api/subject/exam/exam-paper-clear",
    method: "post",
    data: {},
  });
}

/**
 * 错题收藏同统计
 */
export function errorcollectcount(data) {
  return request({
    url: "/api/collect/exam-paper-wrong-total",
    method: "get",
    params: data,
  });
}

/**
 * 题目收藏（时间排序）
 */
export function errorcollecttime(data) {
  return request({
    url: "/pc/collect/exam-paper-question-list",
    method: "get",
    params: data,
  });
}

/**
 * 题目收藏（必学考题、专项练习、精选500）
 */
export function errorcollect(data) {
  return request({
    url: "/api/collect/exam-paper-question-group",
    method: "get",
    params: data,
  });
}

/**
 * 错题收藏（必学考题、专项练习、精选500）
 */
export function errorcollectvip(data) {
  return request({
    url: "/api/collect/exam-paper-wrong-group",
    method: "get",
    params: data,
  });
}

/**
 * 错题数（时间排序）
 */
export function errorcollectwrongtime(data) {
  return request({
    url: "/pc/collect/exam-paper-wrong-list",
    method: "get",
    params: data,
  });
}

/**
 * 试卷详情
 */
export function paperdetail(id) {
  return request({
    url: "/api/subject/exam/exam-paper-detail",
    method: "get",
    params: { id: id },
  });
}

/**
 * 试卷章节回顾
 */
export function paperchapterreview(id) {
  return request({
    url: `/api/subject/exam/exam-paper-chapter-review/${id}`,
    method: "get",
  });
}

/**
 * 收藏题目数量
 */
export function collectcount(data) {
  return request({
    url: "/api/collect/exam-paper-question-total",
    method: "get",
    params: data,
  });
}

/**
 * 收藏题目清空
 */

export function collectclear(data) {
  return request({
    url: "/api/collect/exam-paper-question-clear",
    method: "get",
    params: data,
  });
}

/**
 * 错题数清空
 */
export function errorcollectclear(data) {
  return request({
    url: "/api/collect/exam-paper-wrong-clear",
    method: "get",
    params: data,
  });
}
/**
 * 三里映射
 */
export function questionConfig(data) {
  return request({
    url: "/api/config/question",
    method: "get",
    params: data,
  });
}

/**
 * 真是考场获取试卷
 */
export function realexampaper(data, is_sanli = false, sanli_moni = false) {
  const bool_result = tools.is_qualification();
  if (bool_result === false) {
    // 驾驶证

    if (!is_sanli) {
      return request({
        url: "/api/subject/exam/drive-mock",
        method: "post",
        data: data,
      });
    }

    return request({
      url: !sanli_moni
        ? "/api/subject/exam/three-force-practice"
        : "/api/subject/exam/three-force-mock",
      method: "post",
      data: data,
    });
  } else {
    if (is_sanli) {
      return request({
        url: !sanli_moni
          ? "/api/subject/exam/three-force-practice"
          : "/api/subject/exam/three-force-mock",
        method: "post",
        data: data,
      });
    }

    return request({
      url: "/api/subject/exam/qualification-mock",
      method: "post",
      data: data,
    });
  }
}
